import { render, staticRenderFns } from "./labbtns.vue?vue&type=template&id=4b88fd5d&scoped=true"
import script from "./labbtns.vue?vue&type=script&lang=js"
export * from "./labbtns.vue?vue&type=script&lang=js"
import style0 from "./labbtns.vue?vue&type=style&index=0&id=4b88fd5d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b88fd5d",
  null
  
)

export default component.exports